<template>
  <div>
    <div ref="chartContainer" style="width: 100%; height: 400px;" />
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'BillEChart',
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '收入'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['理论收入', '结算收入'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '理论收入',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '结算收入',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    change(data) {
      const incomesData = []
      const settleData = []
      const date = []
      if (data.length <= 0) {
        return
      }
      data.forEach(res => {
        date.push(res.date)
        incomesData.push(res.total_price)
        settleData.push(res.incomes)
      })
      // console.log('----------------', date)
      // console.log('----------------', incomesData)
      // console.log('----------------', settleData)

      this.option.xAxis.data = date
      this.option.series[0].data = incomesData
      this.option.series[1].data = settleData
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
